<script>
import App from '@/pages/layouts/app.vue'
import {Link, router, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import Form from '@/pages/customers/_form.vue'
import FormButtons from "@/pages/components/form-buttons.vue";

export default {
  components: {
    FormButtons,
    App, Link, Card, Form
  },
  data() {
    return {
      loading: false,
      stayOnPage: 1
    }
  },
  methods: {
    submit() {
      this.loading = true;
      let form = this.$refs.form.form;

      $.ajax({
        url: route('api.v1.customers.store'),
        method: 'POST',
        data: form.data(),
        success: (response) => {
          let target = this.stayOnPage ? route('customers.edit', {customer: response.data.id}) : route('customers.index')
          router.get(target, {
            'success': 'De wijzigingen zijn opgeslagen'
          });
        },
        error: (response) => Helpers.Form.handleErrors(form, response)
      }).always(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<template>
  <App title="Klant toevoegen">
    <form id="customerForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons @backToOverview="stayOnPage = 0" :loading="loading" form-id="customerForm" :cancel-route="route('customers.index')"/>
    </template>
  </App>
</template>